
<template>
  <div class="mt-20 textAlignCenter">
    <slot>
    </slot>
    <div class="ie-flex" v-for="(mflKey, i) in mfls" :key="i">
      <button class="ie-btn" @click="set(mflKey)">
        {{ mflLabel(mflKey) }}
      </button>
      <br>
      <h5>Nivel de Severidad</h5>
      <div class="dark-orange--text">{{asset[mflKey] || '-'}}</div>
      <h5>Factor de Severidad</h5>
      <div class="dark-orange--text">{{ computeSeverityLevel(asset[mflKey],asset.gld) || '-'}}</div>
    </div>
  </div>
</template>

<script>
import { computeSeverityLevel } from '@/functions/general.js';
import { mflTitleForVersion, usesGlobalRiskStandardV2 } from '@/objects/mfl_global_risk.js';

export default {
  props: {
    asset: {
      default: () => { return {}}
    },
    set: {
      default: () => (key) => console.warn(key)
    },
    type:{
      default: 'normal'
    },
    mfls:{
      default:()=>[],
    }
  },
  computed: {
    mflTitles() {
      return mflTitleForVersion(this.asset.global_risk_standard_version);
    },
    syncLegalReputation() {
      return !usesGlobalRiskStandardV2(this.asset.global_risk_standard_version);
    },
  },
  watch:{
    'asset.mfl_legal'(v) {
      if (!this.syncLegalReputation) return;
      this.asset.mfl_reputation = v;
    },
  },
  methods: {
    computeSeverityLevel,
    mflLabel(mflKey) {
      return this.mflTitles[mflKey] || mflKey;
    },
  },
};
</script>
